<template>
  <div>
    <nav
      id="customNavColor"
      class="bg-gray-800 w-full grid grid-cols-4 gap-4 sm:px-8"
      style="height: 100px"
    >
      <div class="my-auto">
        <img class="max-h-full logo" :src="outfitter.logo_path" />
      </div>
      <div class="col-span-2 text-center px-4 my-auto hidden sm:block">
        <span class="text-base font-bold md:text-xl">{{
          outfitter.tag_line
        }}</span>
        <br />
        <a class="block" v-if="outfitter.website" :href="outfitter.website">
          {{ outfitter.website_label }}</a
        >
      </div>
      <div class="text-right col-span-3 sm:col-span-1">
        <base-button-primary
          class="mt-3"
          v-if="showNewOrder"
          @click="handleBack"
          >Create New Order</base-button-primary
        >
        <cart-button
          class="cart-button mt-6"
          v-if="showCart"
          @click="handleCartButton"
        ></cart-button>
      </div>
    </nav>
  </div>
</template>

<script>
import CartButton from "@/components/outfitter/CartButton";
export default {
  name: "CommonNav",
  props: {
    showCart: Boolean,
    showNewOrder: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CartButton,
  },
  methods: {
    handleBack() {
      this.$store.dispatch("order/clear_order").then(() => {
        this.$store.dispatch("search/clear_displayGroups").then(() => {
          let route = "/outfitter/" + this.outfitter.slug;
          if (this.$store.getters["search/isExternal"]) {
            route += "/external";
          }
          this.$router.push(route);
        });
      });
    },
    handleCartButton() {
      this.$router.push({
        name: "cart",
        params: {
          slug: this.$route.params.slug,
          external: this.$route.params.external,
        },
      });
    },
  },
  computed: {
    outfitter: function () {
      return this.$store.getters["search/getOutfitter"];
    },
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .cart-button {
    margin-right: 5px;
  }
  .logo {
    margin-left: 5px;
  }
}
</style>
